export const biz = {
  name: "Horizon Solar & Exterior Care",
  phone: "02 8000 1080",
  email: "info@horizonsolar.com.au",
  address: "Sydney NSW",
  hours: "Mon–Sat 8–6",
  serviceAreas: ["Bondi","Manly","Chatswood","Parramatta","Coogee","Mosman","Surry Hills","Paddington","Double Bay","Rose Bay","Woollahra","Randwick","Maroubra","Cronulla","Sutherland","Miranda","Hurstville","Bankstown","Liverpool","Auburn","Strathfield","Burwood","Ashfield","Leichhardt","Balmain","Rozelle","Glebe","Newtown","Marrickville","Dulwich Hill","Canterbury","Campsie","Lakemba","Roselands","Beverly Hills","Kogarah","Carlton","Rockdale","Brighton-Le-Sands","Kyeambah","Taren Point","Caringbah","Cronulla","Kirrawee","Gymea","Loftus","Engadine","Heathcote","Waterfall","Helensburgh","Stanwell Park","Coledale","Austinmer","Thirroul","Bulli","Wollongong"],
  colors: { primary:"#0A76D1", accent:"#1DC8E8", dark:"#0F1C2E", light:"#F7FAFE" },
 
  // Matches the domain used everywhere else (Meta.jsx, JSON-LD, the business
  // email address).
  siteUrl: "https://horizonsolar.com.au",

   // Only the Facebook URL is a genuine Horizon account (it's a numeric
   // page ID, which survives a business rename). Instagram/TikTok/
   // LinkedIn previously defaulted to the pre-rebrand Arcturus accounts -
   // an empty string here means "hidden until Admin > Website Settings >
   // Social has a real Horizon URL", never a wrong one shown by default.
   socials: {
    facebook: "https://www.facebook.com/profile.php?id=61571124837167&_rdc=1&_rdr",
    instagram: "",
    tiktok: "",
    linkedin: "",
    youtube: "",
  }

  
};